
import Constains from '@/components/Constains';
import router from '@/router'
import { defineComponent, ref, onMounted, } from 'vue';
import { CopyOutlined, } from '@ant-design/icons-vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ja';
import 'dayjs/plugin/updateLocale';
import { holidays } from '@holiday-jp/holiday_jp';
import { useCookies } from 'vue3-cookies';
import axios from 'axios';
import { Input, notification } from 'ant-design-vue';
import type { TableColumnsType } from 'ant-design-vue';

export default defineComponent({
  components: {
    CopyOutlined,
  },
  setup() {
    const cookies  = useCookies();
    const input = ref(Input)

    const loading = ref(false)

    const userColumns = ref<TableColumnsType>([
        {
            title:'LINE ID',
            dataIndex:'lineid',
            ellipsis: true,
            resizable: true,
        },
        {
            title:'名前',
            dataIndex:'name',
            ellipsis: true,
            resizable: true,
        },
        {
            title:'電話番号',
            dataIndex:'tel',
            ellipsis: true,
            resizable: true,
        },
        {
            title:'住所',
            dataIndex:'address',
            ellipsis: true,
            resizable: true,
        },
        {
            title:'登録日',
            dataIndex:'creationdate',
        },
        {
            title:'薬局側システム用利用者コード',
            dataIndex:'pharmacyusercode',
            ellipsis: true,
            resizable: true,
        },
        {
            title:'承認',
            dataIndex:'activated',
            width:'100px'
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ])
    const userDataSource:any = ref([])

    const pharmacyColumns = [
        {
            title:'薬局コード',
            dataIndex:'code',
        },
        {
            title:'薬局名',
            dataIndex:'name',
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ]
    const pharmacyDataSource:any = ref([])

    onMounted(async() => {
      dayjs.locale('ja')
      try{
        await pharmacyReload()
        await userReload()
      } catch(e) {
        console.log(e)
        //cookies.cookies.remove('token');
        //router.push("/login")
      }

    })

    const userVisible = ref(false)
    const userData:any = ref({ })

    const userEditOpen = (user:any) => {
      userData.value = JSON.parse(JSON.stringify(user));
      userVisible.value = true
    }

    const userOK = async() => {
      userData.value.shopcode = cookies.cookies.get('shopcode')
      await userEdit(userData.value)
      userVisible.value = false
    }

    const userReload = async() => {
        userDataSource.value = []
        const token = cookies.cookies.get('token')
        const code = cookies.cookies.get('pharmacy')
        const shopcode = cookies.cookies.get('shopcode')
        loading.value = true
        const res = await axios.get(Constains.managementURL+'/api/pu/user/list?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
                
        if(res.status == 200){
          const data = res.data
          data.forEach((user:any) => {
            let push = {
              lineid:user.lineid,
              name:user.username,
              tel:user.usertel,
              address:user.useraddress,
              creationdate:user.creationdate,
              pharmacyusercode:user.pharmacyusercode,
              activated:user.activated,
            }
            
            try{
              const address = JSON.parse(user.useraddress)
              push.address = '〒'+address.postalcode1+'-'+address.postalcode1+' '+address.prefecture+address.city+address.town+address.building
            }catch{
              //
            }
            userDataSource.value.push(push)

          });
        }
        loading.value = false
    }

    const userEdit = async(user:any) => {
      console.log('userEdit',user)
      const token = cookies.cookies.get('token')
      const code = cookies.cookies.get('pharmacy')
      const shopcode = cookies.cookies.get('shopcode')
      const json = {
        shopcode:shopcode,
        code:code,
        lineid:user.lineid,
        pharmacyusercode:user.pharmacyusercode,
        activated:user.activated,
      }
      loading.value = true
      const res = await axios.put(Constains.managementURL+'/api/pu/user',JSON.stringify(json),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await userReload()
      }
    }

    const pharmacyVisible = ref(false)
    const pharmacyData:any = ref({ })

    const pharmacyEditOpen = (pharmacy:any) => {
      pharmacyData.value.code = pharmacy.code
      pharmacyData.value.name = pharmacy.name
      pharmacyData.value.password = null
      pharmacyVisible.value = true
    }

    const pharmacyOK = async() => {
      
      pharmacyData.value.shopcode = cookies.cookies.get('shopcode')
      await pharmacyEdit(pharmacyData.value)
      pharmacyVisible.value = false
    }

    const pharmacyReload = async() => {
        pharmacyDataSource.value = []
        const token = cookies.cookies.get('token')
        const code = cookies.cookies.get('pharmacy')
        const shopcode = cookies.cookies.get('shopcode')
        loading.value = true
        const res = await axios.get(Constains.managementURL+'/api/pu?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const data = res.data
          pharmacyDataSource.value.push(data)
        }
        loading.value = false
    }

    const pharmacyEdit = async(pharmacy:any) => {
      console.log('pharmacyEdit',pharmacy)
      const token = cookies.cookies.get('token')
      let json:any = {
        shopcode:cookies.cookies.get('shopcode'),
        code:pharmacy.code,
        name:pharmacy.name,
      }
      if(pharmacy.password){
        json.password = pharmacy.password
      }

      loading.value = true
      const res = await axios.put(Constains.managementURL+'/api/pu',JSON.stringify(json),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await pharmacyReload()
      }
    }

    const handleResizeColumn = (w:any, col:any) => {
      col.width = w;
    }

    const copyToClipboard = (str:any) => {
      if (navigator.clipboard){
        navigator.clipboard.writeText(str)
      } 
    }


    return {
        activeKey : ref('2'),
        loading,
        handleResizeColumn,
        pharmacyVisible,
        pharmacyData,
        pharmacyColumns,
        pharmacyDataSource,
        pharmacyOK,
        pharmacyEditOpen,
        userVisible,
        userData,
        userColumns,
        userDataSource,
        userOK,
        userEditOpen,
        copyToClipboard,
    }
  }
})
